import {createSlice} from "@reduxjs/toolkit";
import {
    applyCustomerFirmwareOffer,
    getCustomerFirmwareUpdates as apiGetCustomerFirmwareUpdates,
    removeCustomerFirmwareOffer as apiRemoveCustomerFirmwareOffer
} from "../../../api/api";
import {loaders} from "../../constants";
import {removeLoading, setLoading, setLoadingError} from "./loadingReducer";

/***************** STATE ****************/
const initialState = {
    list: []
};

/************ STATE SLICE **************/

const customerFirmwareUpdatesSlice = createSlice({
    name: 'customerFirmwareUpdates',
    initialState: initialState,
    reducers: {
        setCustomerFirmwareUpdates(state, action) {
            state.list = action.payload
        },
    }
})

/**** EXPORTED ACTIONS AND REDUCERS ****/
export default customerFirmwareUpdatesSlice.reducer;
export const {setCustomerFirmwareUpdates} = customerFirmwareUpdatesSlice.actions;

/**** THUNKS ****/
export const getCustomerFirmwareUpdates = () => {
    return async (dispatch) => {
        try {
            const list = await apiGetCustomerFirmwareUpdates()
            dispatch(setCustomerFirmwareUpdates(list))
        } catch (error) {
            console.error("Error fetching customer firmware updates: ", error)
        }
    }
}

export const applyCustomerFirmwareUpdates = (deviceIdList) => {
    return async (dispatch) => {
        try {
            dispatch(setLoading(loaders.applyCustomerFirmwareOffer))
            await applyCustomerFirmwareOffer(deviceIdList)
            await dispatch(getCustomerFirmwareUpdates())
        } catch (error) {
            dispatch(setLoadingError(loaders.applyCustomerFirmwareOffer))
        } finally {
            dispatch(removeLoading(loaders.applyCustomerFirmwareOffer))
        }
    }
}

export const removeCustomerFirmwareOffer = (deviceIdList) => {
    return async (dispatch) => {
        try {
            dispatch(setLoading(loaders.removeCustomerFirmwareOffer))
            await apiRemoveCustomerFirmwareOffer(deviceIdList)
            await dispatch(getCustomerFirmwareUpdates())
        } catch (error) {
            dispatch(setLoadingError(loaders.removeCustomerFirmwareOffer))
        } finally {
            dispatch(removeLoading(loaders.removeCustomerFirmwareOffer))
        }
    }
}
